import PolicyLayout from "../components/PolicyLayout";

const sections = [
  {
    heading: "1. Introduction",
    paragraphs: [
      "To continually improve your experience on our website, we use cookies that store your preferences and help us remember you. This information helps us understand your interests and show you content we think you'll like.",
      "By visiting the website, you agree and authorize us to store and access cookies and other tracking technologies on your computer or handheld device. Please note that some of our services will not function effectively if your device does not accept cookies.",
      "Take a look at the below information regarding cookies, their settings, and their applications on our website:",
    ],
  },
  {
    heading: "2. What Are Cookies?",
    paragraphs: [
      "Cookies are small text files that are stored on your computer, mobile phone, or other internet-connected device to identify your browser, provide your browsing insights, and remember information about you such as your browsing device or language preference.",
      "They are completely safe and cannot be used to run programs or deliver viruses to any of your devices. Every cookie is unique to your specific web browser. It allows the website to remember your browsing behavior and customize content as per your browsing pattern, improving your website experience.",
    ],
  },
  {
    heading: "3. Why Does FinnCube Use Cookies?",
    items: [
      "To simplify the operation and functionality of our website.",
      "To improve your experience on our website and help you navigate faster and easier.",
      "To customize your user experience and understand what is useful or of interest to you.",
      "To analyze how our website is used and how best we can modify it.",
      "To identify and pre-empt requirements of future prospects and existing account holders, and personalize marketing and sales interactions.",
      "To personalize online advertising based on your interests.",
    ],
  },
  {
    heading: "4. What Type of Cookies Does FinnCube Use?",
    paragraphs: [
      "The following are the types of cookies used on our website:",
      "1. Strictly Necessary Cookies",
      "These cookies are necessary for our website to function and enable you to use website features such as accessing secure areas. They cannot be switched off in our backend. If you choose to remove or disable these cookies, the website may not perform as expected.",
      "2. Performance Cookies",
      "These cookies help enhance the performance of our website and help us make necessary improvements based on your browsing behavior. Information collected by these cookies is anonymous and contains data on how you use the website. For example, identifying your most visited pages, recently searched terms, etc. Once we collect this information, we use it to improve how our website works.",
      "3 Functionality Cookies",
      "These cookies help improve the functionality of our website. These cookies remember your preferences such as location, user name, and language, and provide custom content and features tailored for you.",
      "In the absence of these cookies, the website will be unable to remember the choices you've previously made and won't be able to personalize your browsing experience.",
      "4. Targeting Cookies",
      "These cookies are utilized to customize marketing as per your interests. These are also used to restrict the number of times you are shown advertisements and to measure the effectiveness of a marketing campaign.",
      "These cookies typically track your browsing patterns on other websites too, but do not know who you are. Without these cookies, the ads you encounter will not be as relevant and may not match your interests.",
      "5. Marketing Cookies",
      "These marketing cookies are account-based and enable us to identify future prospects and personalize sales and marketing interactions with users.",
      "6. Analytics and Customization Cookies",
      "All information collected by these cookies is used to help us analyze how our website is being used by visitors, to understand how effective our marketing campaigns are, and to customize our website experience for you.",
    ],
  },
  {
    heading: "11. How You Can Manage Cookies",
    paragraphs: [
      "You can manage or control cookies on most web browsers through their settings preferences. However, limiting the ability of websites to set cookies may worsen the overall user experience, as it won't be personalized to your preferences.",
      "It may also disable saving of customized settings like login information.",
    ],
  },
  {
    heading: "12. Changes to Our Cookie Policy",
    paragraphs: [
      "We may change our cookie policy at any time to accurately reflect current information. We will attempt to notify you of major changes so you can review them before they go into effect.",
    ],
  },
  {
    heading: "13. Further Information About Cookies",
    paragraphs: [
      "Want to learn more about cookies in general and how to manage them? Please visit: www.aboutcookies.org",
    ],
  },
];

function Cookies() {
  return (
    <PolicyLayout
      title="Cookies Policy"
      intro="This policy explains how Finncube Credit Services Pvt. Ltd. uses cookies and similar tracking technologies on our website."
      lastUpdated="March 8, 2026"
      sections={sections}
    />
  );
}

export default Cookies;
